(function () {
  'use strict';

  function initReadMore(root) {
    root.querySelectorAll('[data-lc-read-more]').forEach(function (wrap) {
      var btn = wrap.querySelector('[data-lc-read-more-toggle]');
      var full = wrap.querySelector('[data-lc-read-more-full]');
      var short = wrap.querySelector('[data-lc-read-more-short]');
      if (!btn || !full) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        btn.textContent = open ? 'Read more' : 'Read less';
        full.hidden = open;
        if (short) short.hidden = !open;
      });
    });
  }

  function withQueryParam(key, value) {
    var url = new URL(window.location.href);
    url.searchParams.set(key, value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  function initListing(section) {
    var drawer = section.querySelector('[data-lc-col-filter-drawer]');
    var sortDrawer = section.querySelector('[data-lc-col-sort-drawer]');
    var stickyBar = section.querySelector('[data-lc-col-sticky-bar]');
    var cloneTarget = section.querySelector('[data-lc-col-filter-clone]');
    var sidebar = section.querySelector('[data-lc-col-filter-sidebar]');
    var grid = section.querySelector('[data-lc-col-grid]');

    if (sidebar && cloneTarget && !cloneTarget.querySelector('form')) {
      cloneTarget.appendChild(sidebar.cloneNode(true));
    }

    function openDrawer(el) {
      if (!el) return;
      el.hidden = false;
      el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer(el) {
      if (!el) return;
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
      if (!drawer || drawer.hidden) {
        if (!sortDrawer || sortDrawer.hidden) document.body.style.overflow = '';
      }
    }

    section.querySelectorAll('[data-lc-col-filter-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openDrawer(drawer);
      });
    });
    section.querySelector('[data-lc-col-filter-close]')?.addEventListener('click', function () {
      closeDrawer(drawer);
    });
    drawer?.addEventListener('click', function (e) {
      if (e.target === drawer) closeDrawer(drawer);
    });

    section.querySelector('[data-lc-col-sort-open]')?.addEventListener('click', function () {
      openDrawer(sortDrawer);
    });
    section.querySelector('[data-lc-col-sort-close]')?.addEventListener('click', function () {
      closeDrawer(sortDrawer);
    });
    sortDrawer?.addEventListener('click', function (e) {
      if (e.target === sortDrawer) closeDrawer(sortDrawer);
    });

    section.querySelector('[data-lc-col-sort]')?.addEventListener('change', function (el) {
      withQueryParam('sort_by', el.target.value);
    });

    section.querySelector('[data-lc-col-page-size]')?.addEventListener('change', function (el) {
      withQueryParam('page_size', el.target.value);
    });

    section.querySelectorAll('[data-lc-col-density]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = btn.getAttribute('data-lc-col-density');
        if (!grid) return;
        grid.className = grid.className.replace(/lc-col-main__grid--cols-\d/, 'lc-col-main__grid--cols-' + cols);
        section.querySelectorAll('[data-lc-col-density]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        try {
          localStorage.setItem('lcColGridCols', cols);
        } catch (_) {}
      });
    });

    try {
      var saved = localStorage.getItem('lcColGridCols');
      if (saved && grid) {
        grid.className = grid.className.replace(/lc-col-main__grid--cols-\d/, 'lc-col-main__grid--cols-' + saved);
        section.querySelectorAll('[data-lc-col-density]').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-lc-col-density') === saved);
        });
      }
    } catch (_) {}

    if (stickyBar && window.matchMedia('(max-width: 989px)').matches) {
      stickyBar.removeAttribute('aria-hidden');
      var mainTop = section.offsetTop;
      window.addEventListener(
        'scroll',
        function () {
          stickyBar.classList.toggle('is-visible', window.scrollY > mainTop - 8);
        },
        { passive: true }
      );
    }
  }

  function hideEmptyReviewBadges(root) {
    root.querySelectorAll('.lc-col-card__reviews').forEach(function (el) {
      var text = (el.textContent || '').trim();
      if (text === '' || /no reviews yet/i.test(text) || text === '— No reviews yet') {
        el.setAttribute('data-empty-reviews', 'true');
        el.classList.add('is-empty');
      }
    });
  }

  function initCardReveal(section) {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = section.querySelectorAll('.lc-col-main__item');
    if (!items.length) return;

    items.forEach(function (item, index) {
      item.setAttribute('data-lc-col-reveal', '');
      if (!reduced) {
        item.style.transitionDelay = Math.min(index * 45, 360) + 'ms';
      }
    });

    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }
    );

    items.forEach(function (item) {
      io.observe(item);
    });
  }

  document.querySelectorAll('[data-lc-col-listing]').forEach(function (section) {
    initListing(section);
    initCardReveal(section);
    hideEmptyReviewBadges(section);
    window.setTimeout(function () {
      hideEmptyReviewBadges(section);
    }, 1200);
  });
  document.querySelectorAll('[data-lc-col-page]').forEach(initReadMore);
})();
